import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import { useNavigation } from "@react-navigation/native";
import ReportBackground from "../components/ReportBackground";
import ReportInputEmptyState from "../components/ReportInputEmptyState";
import { ArrowLeft } from "../assets/icons";

export default function ReportInputForm() {
  const navigation = useNavigation();

  return (
    <ReportBackground style={styles.screen}>
      <View style={styles.content}>
        <View style={styles.header}>
          <Pressable
            accessibilityRole="button"
            accessibilityLabel="Kembali"
            onPress={() => navigation.goBack()}
            style={styles.backButton}
          >
            <ArrowLeft />
          </Pressable>
          <Text style={styles.headerTitle}>Input Data</Text>
        </View>

        <ReportInputEmptyState />
      </View>
    </ReportBackground>
  );
}

const styles = StyleSheet.create({
  screen: { flex: 1 },
  content: { flex: 1, paddingHorizontal: 16, paddingTop: 44, paddingBottom: 24 },
  header: { height: 42, borderRadius: 24, backgroundColor: "#FFFFFF", alignItems: "center", justifyContent: "center" },
  backButton: { position: "absolute", left: 14, width: 28, height: 32, justifyContent: "center" },
  headerTitle: { color: "#171717", fontFamily: "Archivo-Bold", fontSize: 12 },
});